import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import BlogPosts from './pages/blog-posts';
import BlogDetail from './pages/blog-detail';
import BlogArticleView from './pages/blog-article-view';
import Projects from './pages/projects';
import About from './pages/about';
import AdminLogin from './pages/admin/login';
import AdminDashboard from './pages/admin/dashboard';
import AdminBlogs from './pages/admin/dashboard/blogs';
import BlogForm from './pages/admin/dashboard/blogs/form';
import AdminProjects from './pages/admin/dashboard/projects';
import ProjectForm from './pages/admin/dashboard/projects/form';
import AdminSkills from './pages/admin/dashboard/skills';
import SkillForm from './pages/admin/dashboard/skills/form';
import AdminExperience from './pages/admin/dashboard/experience';
import ExperienceForm from './pages/admin/dashboard/experience/form';
import AdminNewsletter from './pages/admin/dashboard/newsletter';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms-of-service';
import CookiePolicy from './pages/cookie-policy';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomeLanding />} />
            <Route path="/home-landing" element={<HomeLanding />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog-posts" element={<BlogPosts />} />
            <Route path="/blog-posts/:id" element={<BlogDetail />} />
            <Route path="/blog-article-view/:id" element={<BlogArticleView />} />
            
            {/* Policy Pages */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            
            {/* Admin Auth Routes */}
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/blogs"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminBlogs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/blogs/new"
              element={
                <ProtectedRoute adminOnly={true}>
                  <BlogForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/blogs/edit/:id"
              element={
                <ProtectedRoute adminOnly={true}>
                  <BlogForm />
                </ProtectedRoute>
              }
            />
            
            {/* Projects Admin Routes */}
            <Route
              path="/admin/dashboard/projects"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminProjects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/projects/new"
              element={
                <ProtectedRoute adminOnly={true}>
                  <ProjectForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/projects/edit/:id"
              element={
                <ProtectedRoute adminOnly={true}>
                  <ProjectForm />
                </ProtectedRoute>
              }
            />
            
            {/* Skills Admin Routes */}
            <Route
              path="/admin/dashboard/skills"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminSkills />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/skills/new"
              element={
                <ProtectedRoute adminOnly={true}>
                  <SkillForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/skills/edit/:id"
              element={
                <ProtectedRoute adminOnly={true}>
                  <SkillForm />
                </ProtectedRoute>
              }
            />
            
            {/* Experience Admin Routes */}
            <Route
              path="/admin/dashboard/experience"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminExperience />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/experience/new"
              element={
                <ProtectedRoute adminOnly={true}>
                  <ExperienceForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard/experience/edit/:id"
              element={
                <ProtectedRoute adminOnly={true}>
                  <ExperienceForm />
                </ProtectedRoute>
              }
            />
            
            {/* Newsletter Admin Routes */}
            <Route
              path="/admin/dashboard/newsletter"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminNewsletter />
                </ProtectedRoute>
              }
            />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;
